import { render, staticRenderFns } from "./CatalogManagement.vue?vue&type=template&id=7ba77b5b&scoped=true&"
import script from "./CatalogManagement.vue?vue&type=script&lang=ts&"
export * from "./CatalogManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba77b5b",
  null
  
)

export default component.exports